import React from "react";
import * as MEDIA from "./drupal-media.styles";
import { constant } from "../../constants/contant";

const DrupalMedia = (props: any) => {
  const srcCDN = props.type === "media--image" ? `${constant.URL}${props.src}` : props.src;
  if(props.type === "media--image") {
    return (
      <MEDIA.Banner src={srcCDN} alt={props.alt}/>
    )
  }
  return (
    <MEDIA.Video src={srcCDN}>
    </MEDIA.Video>
  )
};

export default DrupalMedia;
